import React from 'react';
import { useNavigate } from 'react-router-dom';

const CategoryItem = ({ category, type }) => {
  //const navigate = useNavigate();

  // const handleClick = (e) => {
  //   e.preventDefault();
  //   navigate(`${apiUrl}/categories/${id}/locations`);
  // };

  return (
    <a href={`/categories/${category.id}/${type}`} className="tag-link">
      <div className="tagContainer">
        <span className="tagContainerText">{category.name}</span>
        <img 
          className="tagContainerArrow" 
          src="/elements/tagContainerArrow.svg" 
          alt={`Перейти к ${category.name}`}
        />
      </div>
    </a>
  );
};

export default CategoryItem;